export default __webpack_public_path__ + "static/media/DNo.37-5.acc6ca4c.jpg";